/* ============================================================================
   Moving between the central site's own pages without a full reload (Livewire wire:navigate, plan 21).
   The layout turns it on with <html data-navigate> (config ui.central_navigate). Only links to pages built on
   this template get it; panels, sign-in, payment, mini app and landing pages keep loading normally.
   ========================================================================== */
const PAGES = /^\/(?:$|features$|feature\/|package\/|pricing$|page\/|blog(?:\/|$)|portfolio(?:\/|$)|faq(?:\/|$)|docs\/|search$|links$)/;

function navigable(a) {
    if (a.hasAttribute('wire:navigate.hover') || a.hasAttribute('data-native') || a.hasAttribute('download')) return false;
    if (a.target && a.target !== '_self') return false;
    let url;
    try { url = new URL(a.getAttribute('href'), location.href); } catch (e) { return false; }
    if (url.origin !== location.origin || (url.pathname === location.pathname && url.hash)) return false;
    return PAGES.test(url.pathname);
}

/* marks links (also inside <template>s, for the copies Alpine makes later); prefetch starts on hover or press */
function markLinks(root) {
    root.querySelectorAll('a[href]').forEach(a => navigable(a) && a.setAttribute('wire:navigate.hover', ''));
    root.querySelectorAll('template').forEach(t => markLinks(t.content));
}

/* things added to <body> by other scripts (chat widget, alerts): kept across page changes */
const own = new WeakSet();
const remember = () => Array.from(document.body.children).forEach(el => own.add(el));
const isForeign = el => !own.has(el) && el.id !== 'nprogress' && !/^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(el.tagName);

export function setupNavigate({ onPage }) {
    if (!document.documentElement.hasAttribute('data-navigate')) return;
    markLinks(document);
    remember();

    document.addEventListener('livewire:navigating', ({ detail }) => {
        const theme = document.documentElement.className;
        const foreign = Array.from(document.body.children).filter(isForeign);
        detail.onSwap(() => {
            document.documentElement.className = theme;    // theme classes are set by script; the new page's <html> has none
            foreign.forEach(el => document.body.appendChild(el));
            remember();
            markLinks(document.body);
        });
    });

    let first = true, previous = location.href;
    document.addEventListener('livewire:navigated', () => {
        if (first) { first = false; return; }               // Livewire also fires it once on the first load
        if (window._paq) {
            window._paq.push(['setReferrerUrl', previous], ['setCustomUrl', location.href], ['setDocumentTitle', document.title], ['trackPageView']);
        }
        previous = location.href;
        onPage();
    });
}
